import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-489b2dc0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "OSDetail" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "OSDetail_Header" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "OSDetail_HeaderTitle" })
], -1))
const _hoisted_3 = { class: "OSDetail_Main" }
const _hoisted_4 = { class: "OSDetail_TableContainer" }
const _hoisted_5 = { class: "OSDetail_Table OSDetail_DisplayPC" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", null, "書誌CD"),
  /*#__PURE__*/_createElementVNode("th", null, "本体価格"),
  /*#__PURE__*/_createElementVNode("th", null, "ISBN13桁"),
  /*#__PURE__*/_createElementVNode("th", null, "備考"),
  /*#__PURE__*/_createElementVNode("th", null, "発売日")
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", null, "ISBN"),
  /*#__PURE__*/_createElementVNode("th", null, "良品"),
  /*#__PURE__*/_createElementVNode("th", null, "取置在庫数"),
  /*#__PURE__*/_createElementVNode("th", null, "カテゴリ"),
  /*#__PURE__*/_createElementVNode("th", null, "著者名")
], -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", null, "書誌名"),
  /*#__PURE__*/_createElementVNode("th", null, "返品"),
  /*#__PURE__*/_createElementVNode("th", null, "在庫ステータス"),
  /*#__PURE__*/_createElementVNode("th", null, "シリーズ名")
], -1))
const _hoisted_9 = { class: "OSDetail_Table OSDetail_DisplayTB" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", null, "書誌CD"),
  /*#__PURE__*/_createElementVNode("th", null, "書誌名"),
  /*#__PURE__*/_createElementVNode("th", null, "良品"),
  /*#__PURE__*/_createElementVNode("th", null, "ISBN13桁"),
  /*#__PURE__*/_createElementVNode("th", null, "在庫ステータス"),
  /*#__PURE__*/_createElementVNode("th", null, "カテゴリ"),
  /*#__PURE__*/_createElementVNode("th", null, "発売日")
], -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", null, "ISBN"),
  /*#__PURE__*/_createElementVNode("th", null, "本体価格"),
  /*#__PURE__*/_createElementVNode("th", null, "返品"),
  /*#__PURE__*/_createElementVNode("th", null, "取置在庫数"),
  /*#__PURE__*/_createElementVNode("th", null, "備考"),
  /*#__PURE__*/_createElementVNode("th", null, "シリーズ名"),
  /*#__PURE__*/_createElementVNode("th", null, "著者名")
], -1))
const _hoisted_12 = { class: "OSDetail_Table OSDetail_DisplayMulti" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", null, "改装出来予定日"),
  /*#__PURE__*/_createElementVNode("th", null, "重版出来予定日"),
  /*#__PURE__*/_createElementVNode("th", null, "スリップ"),
  /*#__PURE__*/_createElementVNode("th", null, "ケース"),
  /*#__PURE__*/_createElementVNode("th", null, "最新印数")
], -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", null, "改装出来予定数"),
  /*#__PURE__*/_createElementVNode("th", null, "重版出来予定数"),
  /*#__PURE__*/_createElementVNode("th", null, "カバー"),
  /*#__PURE__*/_createElementVNode("th", null, "帯"),
  /*#__PURE__*/_createElementVNode("th", null, "断裁")
], -1))
const _hoisted_15 = { class: "OSDetail_Table OSDetail_DisplaySP" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", null, "書誌CD"),
  /*#__PURE__*/_createElementVNode("th", null, "ISBN"),
  /*#__PURE__*/_createElementVNode("th", null, "書誌名"),
  /*#__PURE__*/_createElementVNode("th", null, "本体価格"),
  /*#__PURE__*/_createElementVNode("th", null, "良品"),
  /*#__PURE__*/_createElementVNode("th", null, "返品"),
  /*#__PURE__*/_createElementVNode("th", null, "ISBN13桁"),
  /*#__PURE__*/_createElementVNode("th", null, "取置在庫数"),
  /*#__PURE__*/_createElementVNode("th", null, "在庫ステータス"),
  /*#__PURE__*/_createElementVNode("th", null, "備考"),
  /*#__PURE__*/_createElementVNode("th", null, "カテゴリ"),
  /*#__PURE__*/_createElementVNode("th", null, "シリーズ名"),
  /*#__PURE__*/_createElementVNode("th", null, "発売日"),
  /*#__PURE__*/_createElementVNode("th", null, "著者名"),
  /*#__PURE__*/_createElementVNode("th", null, "改装出来予定日"),
  /*#__PURE__*/_createElementVNode("th", null, "改装出来予定数"),
  /*#__PURE__*/_createElementVNode("th", null, "重版出来予定日"),
  /*#__PURE__*/_createElementVNode("th", null, "重版出来予定数"),
  /*#__PURE__*/_createElementVNode("th", null, "スリップ"),
  /*#__PURE__*/_createElementVNode("th", null, "カバー"),
  /*#__PURE__*/_createElementVNode("th", null, "ケース"),
  /*#__PURE__*/_createElementVNode("th", null, "帯"),
  /*#__PURE__*/_createElementVNode("th", null, "最新印数"),
  /*#__PURE__*/_createElementVNode("th", null, "断裁")
], -1))

import SearchSimple from "@/components/search/SearchSimple.vue";
import { computed, Ref } from "vue";
import { ref } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import { OrderSearchDetailData } from "../types/zaiko";

// 基本設定関連--------------------------------------------------------

export default /*#__PURE__*/_defineComponent({
  __name: 'OrderSearchDetail',
  emits: ["toggleGlobalHeader"],
  setup(__props, { emit: __emit }) {

const emit = __emit;
const route = useRoute();
const store = useStore();

let modalVisible = ref(false);
let modalVisible_memo = ref(false);
let modalVisible_van = ref(false);
let isActive_KaniFlg = ref(false);
let isActive_SyosaiFlg = false;
let searchAreaToggle = true;
let isActiveSelectAll = false;
let selectedProduct = ref(null);
let search_result: Ref<OrderSearchDetailData>;

const openReferencePopUp = () => {
  emit("toggleGlobalHeader");
};
openReferencePopUp();

// 対象の詳細データをストアから取得する
const getTargetData = () => {
  const isbn = route.params.id;
  const res = store.getters["search/getZaikoDataByIsbn"](isbn);
  search_result = ref(res);
  // 著者名の連結
  let authorArray = [] as string[];
  const authorKeyArray = ["author1", "author2", "author3"];
  authorKeyArray.forEach((author) => {
    if (
      search_result.value[author] !== "" &&
      search_result.value[author] !== null
    ) {
      authorArray.push(search_result.value[author]);
    }
  });
  search_result.value.concatenateAuthor =
    authorArray.length !== 0 ? authorArray.join(",") : "";
  // console.log(search_result.value);
};
getTargetData();

// 日付のフォーマットを変更する
const formatDate = (date: string | null) => {
  if (typeof date === "string") {
    const targetDate = new Date(date);
    const year = targetDate.getFullYear();
    const month = targetDate.getMonth() + 1;
    const day = targetDate.getDate();
    return year + "/" + month + "/" + day;
  } else {
    return null;
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("table", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("tr", null, [
            _createElementVNode("td", null, _toDisplayString(_unref(search_result).syosiCd), 1),
            _createElementVNode("td", null, _toDisplayString(_unref(search_result).hontaiPrice?.toLocaleString()), 1),
            _createElementVNode("td", null, _toDisplayString(_unref(search_result).janCd), 1),
            _createElementVNode("td", null, _toDisplayString(_unref(search_result).itemRemarks), 1),
            _createElementVNode("td", null, _toDisplayString(formatDate(_unref(search_result).releaseDate)), 1)
          ]),
          _hoisted_7,
          _createElementVNode("tr", null, [
            _createElementVNode("td", null, _toDisplayString(_unref(search_result).isbn), 1),
            _createElementVNode("td", null, _toDisplayString(_unref(search_result).items), 1),
            _createElementVNode("td", null, _toDisplayString(_unref(search_result).torioki), 1),
            _createElementVNode("td", null, _toDisplayString(_unref(search_result).category), 1),
            _createElementVNode("td", null, _toDisplayString(_unref(search_result).concatenateAuthor), 1)
          ]),
          _hoisted_8,
          _createElementVNode("tr", null, [
            _createElementVNode("td", null, _toDisplayString(_unref(search_result).title), 1),
            _createElementVNode("td", null, _toDisplayString(_unref(search_result).returnItems), 1),
            _createElementVNode("td", null, _toDisplayString(_unref(search_result).zsName), 1),
            _createElementVNode("td", null, _toDisplayString(_unref(search_result).series), 1)
          ])
        ]),
        _createElementVNode("table", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("tr", null, [
            _createElementVNode("td", null, _toDisplayString(_unref(search_result).syosiCd), 1),
            _createElementVNode("td", null, _toDisplayString(_unref(search_result).title), 1),
            _createElementVNode("td", null, _toDisplayString(_unref(search_result).items), 1),
            _createElementVNode("td", null, _toDisplayString(_unref(search_result).janCd), 1),
            _createElementVNode("td", null, _toDisplayString(_unref(search_result).zsName), 1),
            _createElementVNode("td", null, _toDisplayString(_unref(search_result).category), 1),
            _createElementVNode("td", null, _toDisplayString(formatDate(_unref(search_result).releaseDate)), 1)
          ]),
          _hoisted_11,
          _createElementVNode("tr", null, [
            _createElementVNode("td", null, _toDisplayString(_unref(search_result).isbn), 1),
            _createElementVNode("td", null, _toDisplayString(_unref(search_result).hontaiPrice?.toLocaleString()), 1),
            _createElementVNode("td", null, _toDisplayString(_unref(search_result).returnItems), 1),
            _createElementVNode("td", null, _toDisplayString(_unref(search_result).torioki), 1),
            _createElementVNode("td", null, _toDisplayString(_unref(search_result).itemRemarks), 1),
            _createElementVNode("td", null, _toDisplayString(_unref(search_result).series), 1),
            _createElementVNode("td", null, _toDisplayString(_unref(search_result).concatenateAuthor), 1)
          ])
        ]),
        _createElementVNode("table", _hoisted_12, [
          _hoisted_13,
          _createElementVNode("tr", null, [
            _createElementVNode("td", null, _toDisplayString(formatDate(_unref(search_result).kaisoDate)), 1),
            _createElementVNode("td", null, _toDisplayString(formatDate(_unref(search_result).juhanDate)), 1),
            _createElementVNode("td", null, _toDisplayString(_unref(search_result).slip), 1),
            _createElementVNode("td", null, _toDisplayString(_unref(search_result).bookCase), 1),
            _createElementVNode("td", null, _toDisplayString(_unref(search_result).latestPrints), 1)
          ]),
          _hoisted_14,
          _createElementVNode("tr", null, [
            _createElementVNode("td", null, _toDisplayString(_unref(search_result).kaisoQuantity), 1),
            _createElementVNode("td", null, _toDisplayString(_unref(search_result).juhanQuantity), 1),
            _createElementVNode("td", null, _toDisplayString(_unref(search_result).cover), 1),
            _createElementVNode("td", null, _toDisplayString(_unref(search_result).obi), 1),
            _createElementVNode("td", null, _toDisplayString(_unref(search_result).cutting), 1)
          ])
        ]),
        _createElementVNode("table", _hoisted_15, [
          _hoisted_16,
          _createElementVNode("tr", null, [
            _createElementVNode("td", null, _toDisplayString(_unref(search_result).syosiCd), 1),
            _createElementVNode("td", null, _toDisplayString(_unref(search_result).isbn), 1),
            _createElementVNode("td", null, _toDisplayString(_unref(search_result).title), 1),
            _createElementVNode("td", null, _toDisplayString(_unref(search_result).hontaiPrice?.toLocaleString()), 1),
            _createElementVNode("td", null, _toDisplayString(_unref(search_result).items), 1),
            _createElementVNode("td", null, _toDisplayString(_unref(search_result).returnItems), 1),
            _createElementVNode("td", null, _toDisplayString(_unref(search_result).janCd), 1),
            _createElementVNode("td", null, _toDisplayString(_unref(search_result).torioki), 1),
            _createElementVNode("td", null, _toDisplayString(_unref(search_result).zsName), 1),
            _createElementVNode("td", null, _toDisplayString(_unref(search_result).itemRemarks), 1),
            _createElementVNode("td", null, _toDisplayString(_unref(search_result).category), 1),
            _createElementVNode("td", null, _toDisplayString(_unref(search_result).series), 1),
            _createElementVNode("td", null, _toDisplayString(formatDate(_unref(search_result).releaseDate)), 1),
            _createElementVNode("td", null, _toDisplayString(_unref(search_result).concatenateAuthor), 1),
            _createElementVNode("td", null, _toDisplayString(formatDate(_unref(search_result).kaisoDate)), 1),
            _createElementVNode("td", null, _toDisplayString(_unref(search_result).kaisoQuantity), 1),
            _createElementVNode("td", null, _toDisplayString(formatDate(_unref(search_result).juhanDate)), 1),
            _createElementVNode("td", null, _toDisplayString(_unref(search_result).juhanQuantity), 1),
            _createElementVNode("td", null, _toDisplayString(_unref(search_result).slip), 1),
            _createElementVNode("td", null, _toDisplayString(_unref(search_result).cover), 1),
            _createElementVNode("td", null, _toDisplayString(_unref(search_result).bookCase), 1),
            _createElementVNode("td", null, _toDisplayString(_unref(search_result).obi), 1),
            _createElementVNode("td", null, _toDisplayString(_unref(search_result).latestPrints), 1),
            _createElementVNode("td", null, _toDisplayString(_unref(search_result).cutting), 1)
          ])
        ])
      ])
    ])
  ]))
}
}

})